import { useSelector } from 'react-redux';
import { selectIsBossOrSalesBossLevel } from 'core/userContext';
import { selectEnabledPreviews } from 'modules/app/selectors';

export const useAllowPreviewBaus = (previewKey: string) => {
  const isBaus = useSelector(selectIsBossOrSalesBossLevel);
  const enabledPreviews = useSelector(selectEnabledPreviews);
  return enabledPreviews?.includes(previewKey) && isBaus;
};
